export default "__VITE_ASSET__BaUalE$D__"